import { render, staticRenderFns } from "./LoanDetailModel.vue?vue&type=template&id=17129016&scoped=true&"
import script from "./LoanDetailModel.vue?vue&type=script&lang=js&"
export * from "./LoanDetailModel.vue?vue&type=script&lang=js&"
import style0 from "./LoanDetailModel.vue?vue&type=style&index=0&id=17129016&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17129016",
  null
  
)

export default component.exports